import { render, staticRenderFns } from "./methylaTion.vue?vue&type=template&id=2ac7780f&scoped=true"
import script from "./methylaTion.vue?vue&type=script&lang=js"
export * from "./methylaTion.vue?vue&type=script&lang=js"
import style0 from "./methylaTion.vue?vue&type=style&index=0&id=2ac7780f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac7780f",
  null
  
)

export default component.exports